import React, { useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import TextInputField from "../Shared/TextInputField";
import { isActivePractitionerId, selectActivePractitioners } from "../appSlice";

const mapStateToProps = (state) => ({
  practitioners: selectActivePractitioners(state),
});

const PractitionerSelector = ({ caseManager, practitioners, selectPractitioner }) => {
  const [search, setSearch] = useState("");
  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
    if (!e.target.value) {
      selectPractitioner("");
    }
  };

  const [selectedPractitionerId, setSelectedPractitionerId] = useState("");
  const handleSelectPractitioner = (id) => {
    const selectedPractitioner = practitioners.find((p) => p.practitionerId === id);
    setSearch(`${selectedPractitioner.firstName} ${selectedPractitioner.lastName}`);
    setSelectedPractitionerId(id);
    selectPractitioner(id);
  };

  useEffect(() => {
    // Defaults to an active case manager only while nothing is picked, so a
    // refresh of the list keeps the practitioner staff chose.
    if (
      !selectedPractitionerId &&
      !_.isNull(caseManager) &&
      _.has(caseManager, "practitionerId") &&
      isActivePractitionerId(practitioners, caseManager.practitionerId)
    ) {
      setSelectedPractitionerId(caseManager.practitionerId);
      setSearch(`${caseManager.firstName} ${caseManager.lastName}`);
    }
  }, [caseManager, practitioners, selectedPractitionerId]);

  return (
    <div className="columns is-variable is-1">
      <div className="column">
        <div className="field">
          <TextInputField label="Search and select practitioner" value={search} onChange={handleChangeSearch} />
        </div>
        <div className="table-container practitioner-table">
          <table className="table is-fullwidth is-stripe is-hoverable is-size-7 is-narrow">
            <tbody>
              {practitioners
                .filter(
                  (practitioner) =>
                    `${practitioner.firstName} ${practitioner.lastName}`.toLowerCase().indexOf(search.toLowerCase()) !==
                    -1
                )
                .map((practitioner) => (
                  <tr
                    key={practitioner.practitionerId}
                    className={`${
                      practitioner.practitionerId === selectedPractitionerId ? "is-active " : ""
                    }is-hovered`}
                    onClick={() => handleSelectPractitioner(practitioner.practitionerId)}
                  >
                    <td>
                      {practitioner.firstName} {practitioner.lastName}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(PractitionerSelector);
